<template>
  <div class="section section-basic">
    <div class="container" v-if="!$apollo.queries.equipment.loading">
      <h3 class="title">{{ equipment.title }}</h3>
      <h5 class="description">{{ equipment.content }}</h5>

      <div class="row collections">
        <div class="col-md-6" v-for="image in equipment.images" :key="image.id">
          <img :src="image.url" :alt="equipment.title" class="img-raised" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
export default {
  data() {
    return {
      equipment: null
    };
  },
  apollo: {
    equipment: {
      variables() {
        return {
          id: this.$route.params.item
        };
      },
      query: gql`
        query GetEquipmentDetails($id: ID!) {
          equipment(where: { id: $id }) {
            id
            title
            content
            category {
              id
              name
            }
            images {
              id
              url
            }
          }
        }
      `
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/ItemGallery.vue